import { styled, Slide as BaseSlide } from '@material-ui/core'

export const SNACKBAR_HEIGHT = 50

export const Slide = styled(BaseSlide)(({ theme }) => ({
  left: theme.spacing(8),
  '& > div': {
    transform: 'translateX(80px)',
    padding: 10,
    color: theme.palette.success.main,
    backgroundColor: theme.palette.success.light,
    height: SNACKBAR_HEIGHT,
    borderRadius: 10,
    boxShadow: 'none',
    '& svg': {
      marginRight: theme.spacing(),
    },
  },
}))
